import React from "react";
import { setDangerousHtml } from "@lib/helpers";

const HtmlEmbed = (props) => {
  const createMarkup = (content) => ({ __html: content });

  return (
    <div className={props.className}>
      {props.html && <div dangerouslySetInnerHTML={createMarkup(props.html)} />}

      {props.script && <div ref={setDangerousHtml.bind(null, props.script)} />}
    </div>
  );
};

export default HtmlEmbed;
